import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, watch } from "vue";
import AppAdsList from "./components/AppAdsList.vue";
import AppAdsConfig from "./components/AppAdsConfig.vue";
import AdsSource from "./components/AdsSource.vue";
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'AllH5Ads',
  props: ["dateTime", "isRefresh"],
  setup(__props) {

const activeKey = ref("1");
const loading = ref(false);
const accountId = ref("");
let dateValue: (string | number | Date | dayjs.Dayjs | null | undefined)[] = [];

const props = __props;

watch(() => props.dateTime, (newVal) => {
  //console.log(newVal);
  dateValue = newVal;
});

const tabClick = (key: string) => {
  activeKey.value = key;
};

const handleSwitchTab = (id: string) => {
  activeKey.value = "1";
  accountId.value = id;
};

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, {
    activeKey: activeKey.value,
    "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event)),
    onTabClick: tabClick
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_tab_pane, {
        key: "1",
        tab: "APP广告列表",
        disabled: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(AppAdsList, {
            dateTime: __props.dateTime,
            "is-refresh": __props.isRefresh,
            activeKey: activeKey.value
          }, null, 8, ["dateTime", "is-refresh", "activeKey"])
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_a_tab_pane, {
        key: "2",
        tab: "APP广告配置",
        disabled: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(AppAdsConfig, {
            onSwitchTab: handleSwitchTab,
            "is-refresh": __props.isRefresh
          }, null, 8, ["is-refresh"])
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_a_tab_pane, {
        key: "3",
        tab: "广告源",
        disabled: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(AdsSource, { "is-refresh": __props.isRefresh }, null, 8, ["is-refresh"])
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _: 1
  }, 8, ["activeKey"]))
}
}

})